import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/hanh-chinh/phong-hop'

export function locDanhSachPhongHop(querySt?: string | Record<string, unknown>) {
  try {
    const query = typeof querySt === 'string' ? queryString.parse(querySt) : (querySt || {})
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

/** Danh sách phòng họp (dropdown): gọi lọc với pageSize lớn */
export function layDanhSachPhongHop(chiHoatDong?: boolean) {
  try {
    const params: Record<string, unknown> = { page: 1, pageSize: 500 }
    if (chiHoatDong !== undefined) {
      params.chiHoatDong = chiHoatDong
    }
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function layChiTietPhongHop(meetingRoomId: number) {
  try {
    return axiosApi.get(`${BASE}/${meetingRoomId}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function timPhongHopTheoQr(qrCode: string) {
  try {
    return axiosApi.get(`${BASE}/loc-danh-sach?search=` + encodeURIComponent(qrCode))
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function taoPhongHop(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function capNhatPhongHop(meetingRoomId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${meetingRoomId}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function xoaPhongHop(meetingRoomId: number) {
  try {
    return axiosApi.delete(`${BASE}/${meetingRoomId}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
